import { useState, useRef, useEffect } from 'react';

export default function FadeIn({ children, className = "", id }) {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef(null);

  useEffect(() => {
    // On crée l'observateur
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true); // Déclenche l'animation
          
          // Optionnel : On arrête d'observer une fois apparu (pour ne pas rejouer l'animation si on remonte)
          observer.unobserve(entry.target); 
        }
      });
    }, {
      threshold: 0.1, // Déclenche quand 10% de l'élément est visible à l'écran
      rootMargin: "0px 0px -50px 0px" // Déclenche un poil avant que l'élément touche le bas de l'écran
    });

    // On dit à l'observateur de surveiller notre div
    const currentRef = domRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    // Fonction de nettoyage (très important en React pour éviter les fuites de mémoire)
    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []); // Le tableau vide [] indique que ce code ne tourne qu'au montage du composant

  return (
    <div
      ref={domRef}
      id={id}
      className={`fade-wrapper ${isVisible ? 'is-visible' : ''} ${className}`}
    >
      {/* "children" représente tout ce que vous mettrez à l'intérieur de la balise <FadeIn> */}
      {children}
    </div>
  );
}